import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { UmsService } from '../ums.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import * as moment from 'moment';

@Component({
  selector: 'app-buffer-student-answersheet-code-entry',
  templateUrl: './buffer-student-answersheet-code-entry.component.html',
  styleUrls: ['./buffer-student-answersheet-code-entry.component.scss']
})
export class BufferStudentAnswersheetCodeEntryComponent implements OnInit {

  AnswerSheetForm: FormGroup;

  sessionList: any[] = [];
  SessionFilterList: any[] = [];
  CourseList: any[] = [];
  filteredListCourse: any[] = [];
  examList: any[] = [];
  filteredListExam: any[] = [];

  barcodeList: any[] = [];

  userPermission: any;
  UserCollege: any;
  utp: string;

  // Selected values
  SessionId: any = 0;
  CoCode: any = 0;
  CgCode: any = 0;
  EmId: any = 0;

  Table: boolean = false;
  loading: boolean = false;


  pageSize: number = 10;
  pageSizeOptions: number[] = [5, 10, 20, 50];
  currentPage: number = 1;
  totalItems: number = 0;

 
  message: string = '';
  closeMessage: string = '';

  currentDate: Date;
  dialogRef: MatDialogRef<any>;

  private requestToken = 0;

  constructor(
    private spinner: NgxSpinnerService,
    public umsService: UmsService,
    private fb: FormBuilder,
    private modalPopupService: ModalpopService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem('userPermission'));
    if (this.userPermission && this.userPermission.length > 0) {
      this.UserCollege = this.userPermission[0].CgUi == 'C' ? this.userPermission[0].CgId : '';
    }
    this.utp = sessionStorage.getItem('usertypeee');

    this.SessionId = 0;
    this.CoCode = 0;
    this.CgCode = 0;
    this.EmId = 0;
    this.Table = false;
    this.loading = false;
    this.barcodeList = [];
    this.message = '';
    this.closeMessage = '';

    this.AnswerSheetForm = this.fb.group({
      SessionId: new FormControl('', Validators.required),
      course: new FormControl('', Validators.required),
      EmId: new FormControl('', Validators.required)
    });

    this.currentDate = new Date();
    this.fetchSession();
  }


  fetchSession() {
    this.spinner.show();
    const payload = {};
    payload['SnDefault'] = '';
    payload['SnNo'] = '';

    this.umsService.getSession(payload).subscribe(res => {
      this.spinner.hide();
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.sessionList = [];
    });
  }


  getCourse(data) {
    this.spinner.show();
    this.CoCode = data.CoCode;
    this.CourseList = [];
    this.filteredListCourse = [];
    this.examList = [];
    this.filteredListExam = [];

    this.resetDownstream();

    this.requestToken++;

    const payload = {};
    payload['SessionId'] = this.AnswerSheetForm.value.SessionId;

    this.umsService.getCourse(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
      } else {
        this.CourseList = [];
        this.filteredListCourse = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.CourseList = [];
      this.filteredListCourse = [];
    });
  }

  getExamList(item) {
    this.spinner.show();
    this.CgCode = item.CgCode;

    this.examList = [];
    this.filteredListExam = [];

    this.resetDownstream();
    this.requestToken++;

    const payload = {};
    payload['EmCoCode'] = item.CoCode;

    this.umsService.getExam(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.examList = res.data;
        this.filteredListExam = this.examList.slice();
      } else {
        this.examList = [];
        this.filteredListExam = [];
        this.showAlert(res.message || 'No Exams found', 'Alert', 'fas fa-close');
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.showAlert(ERROR.error.message, 'Alert', 'fas fa-close');
    });
  }

  onExamSelected(examItem: any) {
    if (!examItem || !examItem.EmId) { return; }
    this.EmId = examItem.EmId;

    this.barcodeList = [];
    this.Table = false;
    this.message = '';
    this.closeMessage = '';
    this.resetPagination();
  }


 getBarcodeList(page: number = 1) {
  const formValue = this.AnswerSheetForm.value;

  if (!formValue.SessionId) {
    this.showAlert('Please select Session.', 'Validation Error',
      'fas fa-exclamation-triangle');
    return;
  }
  if (!formValue.course) {
    this.showAlert('Please select Course.', 'Validation Error',
      'fas fa-exclamation-triangle');
    return;
  }
  if (!formValue.EmId) {
    this.showAlert('Please select Exam.', 'Validation Error',
      'fas fa-exclamation-triangle');
    return;
  }

  this.currentPage = page;
  this.loading = true;
  this.spinner.show();
  const token = ++this.requestToken;

  const payload = {
    ExamsBarcodeId: null,
    CoCode: formValue.course,
    EmId: formValue.EmId,
    EsId: null,
    ExamDate: null,
    SearchString: null,
    PageSize: this.pageSize,
    PageNumber: this.currentPage
  };

  this.umsService.getExamsBarcode(payload).subscribe({
    next: (res) => {
      if (token !== this.requestToken) { return; }
      this.loading = false;
      this.spinner.hide();

      const apiMessage = (res && res.message) ? res.message : '';
      if (res.status && res.data && res.data.length > 0) {
        this.barcodeList = res.data.map((item: any) => ({
          ...item,
          AnswerSheetCode: item.Serialno || '',
          _saving: false,
          _saved: !!item.Serialno
        }));

        this.totalItems = Number(res.data[0].TotalRecords) || res.data.length;

        this.Table = true;
        this.message = apiMessage || 'Fetched successfully';
        this.closeMessage = '';
        return;
      }
      this.barcodeList = [];
      this.Table = false;
      this.resetPagination();
      this.message = '';
      this.closeMessage = '';

      this.showAlert(
        apiMessage || 'No Buffer Sheet Data For Selected Exam.',
        'Alert',
        'fas fa-info-circle'
      );
    },
    error: (ERROR: HttpErrorResponse) => {
      if (token !== this.requestToken) { return; }
      this.loading = false;
      this.spinner.hide();
      this.barcodeList = [];
      this.Table = false;
      this.resetPagination();

      this.showAlert(
        ERROR?.error?.message || 'Error while loading list.',
        'Alert',
        'fas fa-close'
      );
    }
  });
}

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex + 1;
    this.getBarcodeList(this.currentPage);
  }

  private resetPagination() {
    this.currentPage = 1;
    this.totalItems = 0;
  }

  saveRow(item: any) {
    const code = (item.AnswerSheetCode || '').toString().trim();

    if (!code) {
      this.showAlert('Please enter Answer Sheet Code.', 'Validation Error',
        'fas fa-exclamation-triangle');
      return;
    }
    if (!item.ExamsBarcodeId) {
      this.showAlert('Invalid record.', 'Validation Error',
        'fas fa-exclamation-triangle');
      return;
    }

    item._saving = true;

    const payload = {
      ExamsBarcodeId: item.ExamsBarcodeId,
      Serialno: code
    };

    this.umsService.amdExamsBarcode(payload).subscribe({
      next: (res) => {
        item._saving = false;
        if (res.status) {
          item.Serialno = code;
          item._saved = true;

          const data = {};
          data['message'] = res.message || 'Answer Sheet Code Saved Successfully';
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService
            .openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        } else {
          this.showError(res.message || 'Save failed');
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        item._saving = false;
        this.showError(ERROR.error.message || 'Save failed');
      }
    });
  }

  private resetDownstream() {
    this.AnswerSheetForm.get('EmId').reset();
    this.barcodeList = [];
    this.Table = false;
    this.message = '';
    this.closeMessage = '';
    this.resetPagination();
  }

  private showAlert(message: string, title: string, icon: string): void {
    const data = {};
    data['message'] = message;
    data['title'] = title;
    data['icon'] = icon;
    this.dialogRef = this.modalPopupService
      .openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  }

  private showError(message: string): void {
    this.showAlert(message, 'Error', 'fas fa-times');
  }
}